<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard ref="wizard"
                       error-color="#EB5E28"
                       :title="title"
                       :subtitle="chineseFields && spanishFields ? translatedFields['patient_registration_form'] : ''"
                       color='#31bebf'>
  
            <tab-content :title="translatedFields['payment']"
                         icon="ti-credit-card">
              <first-step ref="firstStep">
              </first-step>
            </tab-content>
          <button slot="finish" class="display-none"><span>  Pay Now and Submit </span></button>  
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import FirstStep from './Wizard/CardPage.vue'

  export default {
    data () {
      return {
        translatedFields: '',
        fields_en: {
          i_agree_and_submit: 'Submit',
          patient_registration_form: 'Payment',
          payment: 'Payment'
        },
        disabled: false,
        title: process.env.LAB_NAME,
        wizardModel: {}
      }
    },
    components: {
      FirstStep
    },
    mounted: function () {
      this.$sidebar.isMinimized = true
    },
    methods: {
      checkLanguage () {
        if (this.$store.state.lang.value === 'ES') {
          this.translatedFields = this.$store.state.translation_es
        } else {
          if (this.$store.state.lang.value === 'ZH') {
            this.translatedFields = this.$store.state.translation_zh
          } else {
            this.translatedFields = this.fields_en
          }
        }
      }
    },
    computed: {
      language () {
        this.checkLanguage()
        return this.$store.state.lang.value
      },
      spanishFields () {
        return this.$store.state.translation_es
      },
      chineseFields () {
        return this.$store.state.translation_zh
      }
    },
    watch: {
      language () {
        this.checkLanguage()
      }
    }
  }
</script>
<style scoped>
  >>> .vue-form-wizard .wizard-icon-circle {
    background-color: white;
    color: #323737;
    border: 3px solid #323737;
  }

  >>> .checked {
    border: 3px solid #31bebf;
    color: #323737;
  }

  >>> .vue-form-wizard .wizard-nav-pills>li>a {
    color: #323737;
  }


  >>> div[aria-selected="true"]{
    background-color: #31bebf !important;
  }

  .display-none{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Homekit/PaymentWizard.vue